import { Card, Collapse, Tag, Typography } from "antd"
import { ApiOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { authRequest } from "../../../../common/request/authRequest";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { ModuleAccessGate } from "../../common/roles/ModuleAccessGate";
import { PageTitle } from "../../common/PageTitle";
import { EmptyStateBox } from "../../../components/design/EmptyStateBox/EmptyStateBox";

const API_PAGE_INFO = 'Hay situaciones en las que necesitas integrar datos de localiza.me en soluciones a medida. Por ejemplo, si quieres integrar nuestros datos con tus propios dashboards o incluso si quieres hacer un desarrollo muy a medida. Aquí podrás crear una clave de api para acceder a los endpoints de la API de localiza.me.';

export const API = () => (
    <ModuleAccessGate module='API' title='Conexión con API' pageInfo={API_PAGE_INFO}>
        <APIContent />
    </ModuleAccessGate>
);

const APIContent = () => {
    
    const { Paragraph } = Typography;
    const { projectGroup } = useAuth();
    const [config, setConfig] = useState<any>(null);    
    const { t } = useTranslation();
    
	useEffect(() => {
        
        authRequest(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/lzm-api/config',
            { method: 'GET' }
            )
            .then((data) => {                
                setConfig(data);                                                    
            })            
        }, [projectGroup.project]); 
		
    return (
        <Card className='main-card-content'>
        
            <PageTitle title='Conexión con API' pageInfo={API_PAGE_INFO} />
            <br/>
            <h3>Clave de acceso a la api, mantenla protegida:</h3>
            {config && 
                <div>
                    <Tag color='blue' style={{borderRadius:'8px'}}><b>Clave API:</b> {config.apiKey}</Tag>
                    {!config.endpoints?.length ? (
                        <div style={{ margin: '20px 0' }}>
                            <EmptyStateBox
                                icon={<ApiOutlined />}
                                title="No hay endpoints disponibles"
                                description="Cuando se activen endpoints para tu proyecto aparecerán aquí con su documentación."
                            />
                        </div>
                    ) : (
                        config.endpoints.map((endpoint: string) => {
                            return (
                                <div key={endpoint} style={{background:'white', margin:'15px', padding:'15px'}}>
                                    <h2>{ENDPOINTS[endpoint]?.description}</h2>
                                    <Collapse>
                                        <Collapse.Panel key="1" header={ENDPOINTS[endpoint]?.path}>
                                            <div>
                                                <code>   
                                                <b>Request:</b>                                                    
                                                    <Paragraph 
                                                        style={{ 
                                                            whiteSpace: 'pre-wrap', 
                                                            padding: '12px'
                                                        }}>                           
                                                        {ENDPOINTS[endpoint]?.input}
                                                    </Paragraph>                                                        
                                                </code>
                                            </div>
                                            <div>
                                                <code>   
                                                <b>Response:</b>                                                    
                                                    <Paragraph 
                                                        style={{ 
                                                            whiteSpace: 'pre-wrap', 
                                                            padding: '12px'
                                                        }}>                           
                                                        {ENDPOINTS[endpoint]?.output}
                                                    </Paragraph>                                                        
                                                </code>
                                            </div>
                                        </Collapse.Panel>

                                    </Collapse>                                                                                                            
                                </div>
                            )
                        })
                    )}
                </div>			
            }
        </Card>    
    )
}


  const PERFORMANCE_REQUEST = 
  `
    @PathVariable   apiKey          La api key de tu proyecto
    @PathVariable   projectName     El nombre del proyecto
    @RequestParam   date            Fecha en los últimos 7 días en formato yyyy-MM-dd (últimos 7 días)
`;

const LAST_COMMENTS_REQUEST = 
  `
    @PathVariable   apiKey          La api key de tu proyecto
    @PathVariable   projectName     El nombre del proyecto
    @RequestParam   startDate       Fecha en los últimos 7 días en formato yyyy-MM-dd HH:mm:ss 
    @RequestParam   endDate         Opcional para el paginado (por defecto hora actual)
    @RequestParam   stars           Opcional Puntuación (por defecto 1,2)

    Max número de resultados: 100, para obtener más páginas volver a llamar con endDate = {fecha de la última reseña}
`;

const LAST_REVIEWS_REQUEST = 
  `
    @PathVariable   apiKey          La api key de tu proyecto
    @PathVariable   projectName     El nombre del proyecto
    @RequestParam   startDate       Opcional (por defecto hoy a primera hora) Fecha de los últimos 7 días en formato yyyy-MM-ddTHH:mm:ss 
    @RequestParam   nextPageToken   Opcional Fecha en formato yyyy-MM-ddTHH:mm:ss (para paginar con el valor de la response anterior)
`;

const LAST_REMOVED_REVIEWS_REQUEST = 
  `
    @PathVariable   apiKey          La api key de tu proyecto
    @PathVariable   projectName     El nombre del proyecto
    @RequestParam   startDate       Opcional (Por fecha de Borrado, por defecto hoy a primera hora) Fecha de los últimos 7 días en formato yyyy-MM-ddTHH:mm:ss 
    @RequestParam   nextPageToken   Opcional Fecha en formato yyyy-MM-ddTHH:mm:ss (para paginar con el valor de la response anterior)
`;

const LOCATIONS_REQUESTS = 
  `
    @PathVariable   apiKey          La api key de tu proyecto
    @PathVariable   projectName     El nombre del proyecto
`;

  const PERFORMANCE_RESPONSE = 
  `
[
    {
        "project":"Mi Proyecto",  
        "placeId":"ChIJ98acYxfd8pBIR2WNjyxU5QJA",
        "year":2025,
        "month":10,
        "day":25,
        "impressions":6,
        "directionRequests":2,
        "callClicks":0,
        "webClicks":0
    },
    {
        "project":"Mi Proyecto",
        "placeId":"ChIJi8xfduipBIRKw85iJQ_60E",
        "year":2025,
        "month":10,
        "day":25,
        "impressions":3,
        "directionRequests":0,
        "callClicks":0,
        "webClicks":0
    }
]`;

const LAST_REVIEWS_RESPONSE_CUSTOM = `{
    "reviews":[
       {
          "reviewId":"AbFvOqmlt7xP1rLe-seDbV8C8Nu5fiFcGfs2yFmWT2UgRSQPalF50mOkTtmMzxBzVoJTeKmdfMYi4g",
          "project":"Mis Negocios",
          "placeId":100297473360558154421,
          "starRating":5,
          "comment":"Mi pelo sufre mucho con las mechas y han conseguido dejarme un rubio precioso y sin castigarlo. Estoy encantada. A parte del buen trabajo, el buen rollo que transmite el equipo . Para mi un 10!! Lo recomiendo siempre",
          "author":"Cristina",
          "replyComment":"¡Gracias, Cristina! Nos encanta saber que estás tan satisfecha con el resultado de tu rubio y con el ambiente de nuestro equipo.",
          "createdTime":"2025-02-28T11:50:01.387",
          "updatedTime":"2025-02-28T11:50:01.387"
       },
       {
          "reviewId":"AbFvOql_kS_YTDtgt8WOxcatbxZ9oHur4Be8LDVVAByISinALFaEENiaLs7URQHp-vsY3ebiEOjj",
          "project":"Mis Negocios",
          "placeId":6887396555565524217,
          "starRating":5,
          "comment":null,
          "author":"Javier Perez",
          "replyComment":"¡Hola, Javier! Muchas gracias por tu calificación de 5 estrellas.",
          "createdTime":"2025-01-29T09:00:24.013",
          "updatedTime":"2025-01-29T09:00:24.013"
       }
    ],
    "nextPageToken":"2024-11-19T20:51:18.211"
 }`;

 const LAST_REVIEWS_RESPONSE = `{
    "reviews":[
       {
          "reviewId":"AbFvOqmlt7xP1rLe-seDbV8C8Nu5fiFcGfs2yFmWT2UgRSQPalF50mOkTtmMzxBzVoJTeKmdfMYi4g",
          "project":"Mis Negocios",
          "placeId":100297473360558154421,
          "starRating":5,
          "comment":"Mi pelo sufre mucho con las mechas y han conseguido dejarme un rubio precioso y sin castigarlo. Estoy encantada. A parte del buen trabajo, el buen rollo que transmite el equipo . Para mi un 10!! Lo recomiendo siempre",
          "commentLabels":"(+) equipo (+) rubio"
          "author":"Cristina",
          "replyComment":"¡Gracias, Cristina! Nos encanta saber que estás tan satisfecha con el resultado de tu rubio y con el ambiente de nuestro equipo.",
          "title":"Pelu2000",
          "locality":"Badalona",
          "administrativeArea":"Barcelona",
          "address":"Avenida Josep Tarradellas 23",
          "createdTime":"2025-02-28T11:50:01.387",
          "updatedTime":"2025-02-28T11:50:01.387"
       },
       {
          "reviewId":"AbFvOql_kS_YTDtgt8WOxcatbxZ9oHur4Be8LDVVAByISinALFaEENiaLs7URQHp-vsY3ebiEOjj",
          "project":"Mis Negocios",
          "placeId":6887396555565524217,
          "starRating":5,
          "comment":null,
          "commentLabels":null
          "author":"Javier Perez",
          "replyComment":"¡Hola, Javier! Muchas gracias por tu calificación de 5 estrellas.",
          "title":"Pelu2000",
          "locality":"Badalona",
          "administrativeArea":"Barcelona",
          "address":"Avenida Josep Tarradellas 23",
          "createdTime":"2025-01-29T09:00:24.013",
          "updatedTime":"2025-01-29T09:00:24.013"
       }
    ],
    "nextPageToken":"2024-11-19T20:51:18.211"
 }`;

 const LAST_REMOVED_REVIEWS_RESPONSE = `{
    "removedReviews":[
       {
          "reviewId":"AbFvOqmvIdcEUvgHPE_brhDA5Jz50WEP9F5TLfdfd3P1wLNLqPlP41MysoSWd2pWTWUb5BHEuZWA",
          "removedDate":"2026-05-05T09:09:54.789"
       },
       ....
       {
          "reviewId":"AbFvOqkYtcMhzhjMtRon-uWyqaGN8pk4pmodfsdfukqzJLqmMKEjpJQcYTVPEoLGAD59C",
          "removedDate":"2026-05-05T09:09:54.118"
       }
    ],
    "nextPageToken":"2026-05-05T09:09:54.118"
 }`;

 const LOCATIONS_RESPONSE = `[
    {
       "title":"Deep Coding",
       "locality":"Badalona",
       "administrativeArea":"Barcelona",
       "address":"C/Carme, 2, Despacho 8",
       "placeId":"ChIJ86R8ZsdfsdfKwdfdsfsdfsdfd"
    },
    {
       "title":"LOCALIZA.ME",
       "locality":"Barcelona",
       "administrativeArea":"Barcelona",
       "address":"Avenida Josep Tarradellas 38",
       "placeId":"ChIJi86R8ZsdfsdfKw85iJQ_60E"
    }
 ]`;

  const LAST_COMMENTS_RESPONSE = `
    CSV con cabecera
    "Tienda", "Puntuación", "Casuística", "Mensaje", "Resumen del Mensaje", "Fecha", "Fecha simplificada"
  `;

export const ENDPOINTS: any = {

    GET_LAST_COMMENTS_AS_CSV: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/comments?startDate=2025-10-25%2010:43:41&stars=1,2,3,4,5", 
        description:"Comentarios en CSV", 
        input: LAST_COMMENTS_REQUEST,
        output: LAST_COMMENTS_RESPONSE
    },		
    GET_LAST_REVIEWS: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/reviews", 
        description:"Últimas reseñas", 
        input: LAST_REVIEWS_REQUEST,
        output: LAST_REVIEWS_RESPONSE_CUSTOM
    },		
    GET_PERFORMANCE: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/performance?date=2025-10-25", 
        description:"Métricas de rendimiento por local", 
        input: PERFORMANCE_REQUEST,
        output: PERFORMANCE_RESPONSE
    },		
    GENERIC_GET_REVIEWS: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/lzm/reviews", 
        description:"Últimas reseñas", 
        input: LAST_REVIEWS_REQUEST,
        output: LAST_REVIEWS_RESPONSE
    },		
    GENERIC_GET_REMOVED_REVIEWS: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/lzm/reviews-removed", 
        description:"Últimas reseñas borradas", 
        input: LAST_REMOVED_REVIEWS_REQUEST,
        output: LAST_REMOVED_REVIEWS_RESPONSE
    },		
    GENERIC_GET_LOCATIONS: {
        path:"GET https://api.localiza.me:443/v1.0/api/{apiKey}/project/{projectName}/lzm/locations", 
        description:"Lista de Locales", 
        input: LOCATIONS_REQUESTS,
        output: LOCATIONS_RESPONSE
    }
};